const getObjectIds = (ids: string) => {
  if (ids.length > 0) {
    return { objectDb: Number(ids.split(",")[0]), objectId: Number(ids.split(",")[1]) };
  } else {
    return null;
  }
};

export default getObjectIds;

export const getConvertIds = (ids: string) => {
  if (ids.length > 0) {
    return `${Number(ids.split("/")[1])},${Number(ids.split("/")[0])}`;
  } else {
    return "0,0";
  }
};
